import React from 'react';
import ImagePreview from '../layout/ImagePreview';
import Instructions from '../instructions/Instructions';
import ColorContextProvider from '../../contexts/ColorContext';
import LogoContextProvider from '../../contexts/LogoContext';
import NamePositionContextProvider from '../../contexts/NamePositionContext';

const Create = () => {
    return (
        <ColorContextProvider>
            <LogoContextProvider>
                <NamePositionContextProvider>
                    <Instructions />
                    <ImagePreview />
                </NamePositionContextProvider>
            </LogoContextProvider>
        </ColorContextProvider>     
    )
}

export default Create;
